import { formatUSNumber } from './stringUtilities';
import normalizeMessageType from './normalizeMessageType';
import toTitleCase from './toTitleCase.js';

const getWebFormName = (data) => {
  if (data.type === 'phone_calls') {
    return false;
  }
  let formFields = {};
  try {
    formFields = JSON.parse(data.form_fields);
  } catch (e) {}
  const name = `${data.first_name || ''} ${data.last_name || ''}`.trim() || (formFields || {}).Name || '';

  return name.length > 0 ? name : 'Web Form (No Name)';
};

const getThreadMetaName = (message) => {
  if (!message.thread_meta) {
    return undefined;
  }
  return `${message.thread_meta.first_name || ''} ${message.thread_meta.last_name || ''}`.trim();
};

export const getNonLeadMessageName = (message) =>
  ({
    emails: getThreadMetaName(message) || message.email_from_primary,
    phone_calls: getThreadMetaName(message) || message.caller_name || message.full_name || (message.caller_city && `Call From ${toTitleCase(message.caller_city)}, ${message.caller_state || ''}`) || 'Phone Call',
    web_forms: getThreadMetaName(message) || getWebFormName(message),
    texts: getThreadMetaName(message) || ((message.platform || {}).code === 'facebookmessenger' ? 'Facebook Messenger' : formatUSNumber(message.from_phone_number || message.phone)),
  }[normalizeMessageType(message.type)]);

export default getNonLeadMessageName;
